import Interaction from 'ol/interaction/Interaction';

import { TooltipOverlay } from 'cadenza/map/tooltip/tooltip-overlay';

export class TooltipInteraction extends Interaction {

  #map;
  #tooltip;
  #message;

  constructor (map, message, interactionOptions = {}) {
    super(interactionOptions);
    this.setActive(false);
    this.#map = map;
    this.#message = message;
    this.#tooltip = new TooltipOverlay(map);

    this.on('change:active', () => {
      if (this.getActive()) {
        this._onActivation();
      } else {
        this._onDeactivation();
      }
    });
  }

  get map () {
    return this.#map;
  }

  _onActivation () {
    this.#tooltip.activate();
    this.#tooltip.message = this.#message;
    this.#tooltip.show();
  }

  _onDeactivation () {
    this.#tooltip.deactivate();
  }

}
